import { returnHistory } from './return-history-en.i18n';

export const en = {
  returnHistory,
};
